module.exports = __webpack_public_path__ + "static/about-09d88dec86969a22bf6405df7b592c0e.jpg";